import React from "react";
import Button from "@mui/material/Button";

import { RoutesEnum } from "src/library/types/types";
import { customButtonStyle } from "src/library/styles/theme";

import { Link } from "react-router-dom";

type RegisterButtonProps = {
  buttonText: string;
  size?: string;
};

export default function LinkToRegisterButton(props: RegisterButtonProps) {
  const { buttonText, size } = props;

  return (
    <Link
      to={RoutesEnum.Register}
      style={{ textDecoration: "none" }}
      aria-label="link to register form"
    >
      <Button variant="contained" color="secondary" sx={customButtonStyle(size)}>
        {buttonText}
      </Button>
    </Link>
  );
}
